import { create } from 'zustand';
import { supabase } from '@/integrations/supabase/client';

export interface User {
  id: string;
  email: string;
  fullName?: string;
}

interface UserStore {
  users: User[];
  fetchUsers: () => Promise<void>;
}

const useUserStore = create<UserStore>((set) => ({
  users: [],
  fetchUsers: async () => {
    try {
      // Fetch from public.users table
      const { data, error } = await supabase
        .from('users')
        .select('id, email, raw_user_meta_data')
        .not('email', 'is', null)
        .order('email');

      console.log('[fetchUsers] public.users result:', data, error);

      if (error) {
        console.error('[fetchUsers] Error fetching users from public.users:', error);
        throw error;
      }

      const transformedUsers = data.map((user: any) => ({
        id: user.id,
        email: user.email,
        fullName: user.raw_user_meta_data?.full_name || user.raw_user_meta_data?.name || null,
      }));

      set({ users: transformedUsers });
    } catch (error) {
      console.error('[fetchUsers] Error in fetchUsers:', error);
      throw error;
    }
  },
}));

export default useUserStore; 